import { IEventWasCreated } from '../../../actions/bookingCalendar/event/requestCreateEvent'
import { IEventsStore } from '../../events'

export default function(
  state: IEventsStore,
  action: IEventWasCreated,
): IEventsStore {
  return {
    ...state,
    events: [...state.events, action.event],
  }
}
